import UrunlerService from '../../../services/UrunlerService'
// import _ from 'lodash';

export default {
    namespaced: true,
    state: () => ({
        urunAlanlari: [],
        urunBoyutlari: []
    }),
    getters: {

    },
    mutations: {
        urunAlanlari: (state, data) => {
            state.urunAlanlari = data
        },
        urunBoyutlari: (state, data) => {
            state.urunBoyutlari = data
        }
    },
    actions: {
        urunEkle: ({commit}, urunData) => {
            return new Promise((resolve, reject) => {
                UrunlerService.urunEkle(urunData).then(res => {
                    commit
                    resolve(res)
                }).catch(err => {
                    reject(err)
                })
            })
        },
        urunAlanlari: ({commit}) => {
            return new Promise((resolve, reject) => {
                UrunlerService.urunAlanlari().then(res => {
                    commit('urunAlanlari', res.data)
                    resolve(res)
                }).catch(err => {
                    reject(err)
                })
            })
        },
        urunBoyutlari: ({commit}) => {
            return new Promise((resolve, reject) => {
                UrunlerService.urunBoyutlari().then(res => {
                    commit('urunBoyutlari', res.data)
                    resolve(res)
                }).catch(err => {
                    reject(err)
                })
            })
        }
    }
}